const fieldTemplateComponentSettingOwningClass = {
    FIELD_TEMPLATE : 0,

    UI_FIELD : 1

};

angular.module('gw-um-j2js')
    .constant('fieldTemplateComponentSettingOwningClass', fieldTemplateComponentSettingOwningClass);